import React from 'react';
import styled from "styled-components";
import data from './CookieTableData.json';

const CookieTable = () => {
    const cookies = data.CookieTableData;

    return (
        <CookieTableWrapper>
            <div className="table-container">
                <table>
                    <tbody>
                    <tr>
                        <td>Çerez İsmi</td>
                        <td>Sağlayıcı</td>
                        <td>Saklama Süresi</td>
                        <td>Kullanım Amacı</td>
                    </tr>
                    {cookies.map((cookie, index) => (
                        <tr key={index}>
                            <td dangerouslySetInnerHTML={{__html: cookie.name}}></td>
                            <td dangerouslySetInnerHTML={{__html: cookie.provider}}></td>
                            <td>{cookie.storageDuration}</td>
                            <td>{cookie.purpose}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </CookieTableWrapper>

    );
};

export const CookieTableWrapper = styled.div`
  .table-container {
    overflow-x: auto;
  }

  table {
    width: 100%;
    border: 1px solid var(--color-gray-storm);
    text-align: left;
    display: table;
    border-collapse: separate;
    box-sizing: border-box;
    text-indent: initial;
    border-spacing: 2px;
  }
  
  tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
  }

  th, td {
    padding: 8px;
    border: 1px solid var(--color-gray-storm);
    text-align: left;
    font-size: 14px;
    letter-spacing: 0;

    & :before, & :after {
      content: none;
      box-sizing: border-box;
      font-size: 14px;
    }
  }

  tr {
    display: table-row;
  }

  th {
    background-color: #f2f2f2;
  }

  @media (max-width: 600px) {
    table {
      border: 0;
    }

    table tr {
      margin-bottom: 10px;
      border: 1px solid #ccc;
    }

    table td {
    }

    table td::before {
      content: attr(data-label);
      float: left;
      font-weight: bold;
    }
  }
`;

export default CookieTable;
